import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: MainPaper dinámico según tema - AMPLIADO para mejor UX
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "auto",
    overflowX: "auto", // ✅ Permitir scroll horizontal si es necesario
    minWidth: "100%", // ✅ Asegurar ancho mínimo completo
    width: "100%", // ✅ Ancho completo del contenedor
    ...theme.scrollbarStyles,
    borderRadius: '12px',
    boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },

  // ✅ CORREGIDO: TableHeader dinámico según tema - AMPLIADO
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    padding: theme.spacing(1.5),
    whiteSpace: 'nowrap', // ✅ Evitar que el texto se corte
    minWidth: '120px', // ✅ Ancho mínimo para cada columna
  },

  // ✅ CORREGIDO: TableRow dinámico según tema - AMPLIADO
  tableRow: {
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.action.hover,
    },
    "& td": {
      color: theme.palette.text.primary,
      borderBottom: `1px solid ${theme.mode === 'dark' ? '#4B5563' : 'rgba(224, 224, 224, 0.5)'}`,
      whiteSpace: 'nowrap', // ✅ Evitar que el texto se corte
      padding: theme.spacing(1.5), // ✅ Padding adecuado para mejor legibilidad
    },
  },

  // ✅ ESTILOS DE BOTONES MEJORADOS
  primaryButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },

  // ✅ ESTILOS DE ICONOS MEJORADOS
  actionIcon: {
    color: '#1976d2',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.1)',
    },
  },

  deleteIcon: {
    color: '#d32f2f',
    '&:hover': {
      backgroundColor: 'rgba(211, 47, 47, 0.1)',
    },
  },

  pauseIcon: {
    color: '#ff9800',
    '&:hover': {
      backgroundColor: 'rgba(255, 152, 0, 0.1)',
    },
  },

  playIcon: {
    color: '#4caf50',
    '&:hover': {
      backgroundColor: 'rgba(76, 175, 80, 0.1)',
    },
  },

  stopIcon: {
    color: '#d32f2f',
    '&:hover': {
      backgroundColor: 'rgba(211, 47, 47, 0.1)',
    },
  },

  // ✅ CORREGIDO: SearchField dinámico según tema
  searchField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
  },

  // ✅ ESTILOS DE ESTADO MEJORADOS
  statusChip: {
    fontWeight: 'bold',
    borderRadius: 16,
    padding: theme.spacing(0.5, 1),
  },

  statusInactive: {
    backgroundColor: '#9e9e9e',
    color: 'white',
  },

  statusScheduled: {
    backgroundColor: '#2196f3',
    color: 'white',
  },

  statusInProgress: {
    backgroundColor: '#ff9800',
    color: 'white',
  },

  statusCancelled: {
    backgroundColor: '#f44336',
    color: 'white',
  },

  statusFinished: {
    backgroundColor: '#4caf50',
    color: 'white',
  },
}));
